import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { CloseMaterialIcon } from "Icons/MaterialIcons";
import { IconButton } from "@material-ui/core";
import "./ModalComponent.scss";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		position: "absolute",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[5],
		borderRadius: "5px",
		padding: theme.spacing(2, 4, 3),
	},
	scrollable: {
		maxHeight: "70vh",
		width: "100vh",
		overflowY: "scroll",
	},
}));

const ModalComponent = ({
	stateModal,
	setStateModal,
	classNameBtnOpenModal,
	closeAutomatically = false,
	scrollable = false,
	...props
}) => {
	const classes = useStyles();
	const [openModal, setOpen] = React.useState(false);

	const handleOpenModal = () => {
		setOpen(true);
		setStateModal(true);
	};
	const handleCloseModal = () => {
		setOpen(false);
		setStateModal(false);
	};

	useEffect(() => {
		if (!stateModal) {
			setOpen(false);
		}
	}, [stateModal]);

	return (
		<>
			<button className={classNameBtnOpenModal} onClick={handleOpenModal}>
				{props.slotOpenModal}
			</button>
			<Modal
				className={classes.modal}
				open={openModal}
				onClose={handleCloseModal}
				BackdropComponent={Backdrop}
				// closeAfterTransition
				// disablePortal
				// closeAfterTransition
				// disableEnforceFocus
				BackdropProps={{
					timeout: 500,
				}}
			>
				<Fade in={openModal}>
					<div
						className={
							scrollable
								? `${classes.scrollable} ${classes.paper}`
								: classes.paper
						}
					>
						<IconButton className="closeBtn" onClick={handleCloseModal}>
							<CloseMaterialIcon className="closeBtn__closeIcon" />
						</IconButton>
						<div className="modalContent">{props.children}</div>
					</div>
				</Fade>
			</Modal>
		</>
	);
};

export default ModalComponent;
